import React from "react";

function Disclaimer() {
  return (
    <section className="bg-[#00AEF3] py-4">
      <p className=" text-center text-white text-lg font-semibold mb-1">Disclaimer</p>
      <p className=" text-center text-sm font-normal max-w-4xl mx-auto text-white px-4 ">
        The information provided on this website by Unify Wellness Pvt Ltd is
        for general informational purposes only. While we strive to keep the
        information up-to-date and accurate, we make no representations or
        warranties of any kind, express or implied, about the completeness,
        accuracy, reliability, suitability, or availability concerning the
        website or the information, products, services, or related graphics
        contained on the website for any purpose.
      </p>
    </section>
  );
}

export default Disclaimer;
